import Tools from "../Tools";
import { AIResponse } from "../vo/AIResponse";
import VoiceModelVO from "../vo/edgetts/VoiceModelVO";
import { SSEResponse } from "../vo/SSEResponse";

export enum AudioCodeModelEnum {
    /**
     * 未知
     */
    None = -1,
    /**
     * 图片格式
     */
    Audio = 0,
    /**
     * Base64字符串
     */
    Base64 = 1,
    /**
     * 返回连接
     */
    Link = 2
}

/**
 * 文本转换声音
 */
export type InputChatCompletions = {
    UseStream: boolean,
    UseModel: string,
    Messages: string[]
};

/**
 * 输入图片生成
 */
export type InputImagesGenerations = {
    UseModel: boolean,
    Prompt: string
};

export type InputDocumentInterpretation = {
    UseStream: boolean,
    UseModel: string,
    FileUrl: string,
    Message: string
};

export type InputImageInterpretation = {
    UseStream: boolean,
    UseModel: string,
    FileUrl: string,
    Message: string
};

export type InputConvertTextToAudio = {
    /**
     * 要转换的文本
     */
    Text: string;
    /**
     * 声音模式
     */
    AudioModel: AudioCodeModelEnum;
    /**
     * 语音模型全名称
     */
    ModelFullName: string;
    /**
     * 音调 示例 +0Hz
     */
    Pitch?: string;
    /**
     * 语速 示例 +0% 
     */
    Rate?: string;
    /**
     * 音量(额外增加的) 示例 +0% 默认(这是正常音量)
     */
    Volume?: string
};

export default class AIApi {

    /**
     * 获取语音合成模型列表
     * @param filterLocale 筛选 zh-CN 是中文
     */
    public GetVoiceModelListAsync(filterLocale?: string) {
        return Tools.FetchAsync<VoiceModelVO[]>("AI/GetVoiceModelList", {
            filterLocale: filterLocale
        }, "GET");
    }

    /**
     * 文本转换音频
     * @param modelFullName 模型全称
     * @param text 要转换的文本
     * @param audioModel 声音模式 
     * @param pitch 音调 示例 +0Hz
     * @param rate 语速 示例 +0% 
     * @param volume 音量 示例 +0% (默认值 正常音量)
     * @returns 
     */
    public ConvertTextToAudioAsync(
        modelFullName: string,
        text: string,
        audioModel: AudioCodeModelEnum = AudioCodeModelEnum.Audio,
        pitch?: string,
        rate?: string,
        volume?: string
    ) {
        const input: InputConvertTextToAudio = {
            Text: text,
            AudioModel: audioModel,
            ModelFullName: modelFullName,
            Pitch: pitch,
            Rate: rate,
            Volume: volume
        };
        return Tools.FetchAsync<{
            Base64Audio: string,
            Link: string,
            /**
             * 时长
             */
            MediaDuration: number
        } | Blob>("AI/ConvertTextToAudio", input, "POST", "application/json");
    }



    /**
     * AI聊天
     */
    public async ChatCompletionsAsync(input: InputChatCompletions, OnStreamFun?: (data: SSEResponse | '[DONE]') => void) {
        if (input.UseStream) {
            if (!OnStreamFun)
                throw new Error("流模式必须定义回调!");
            return Tools.FetchSSEAsync("AI/ChatCompletions", input, OnStreamFun);
        }
        else {
            const resp = await Tools.FetchAsync<AIResponse[]>("AI/ChatCompletions", input, "POST");
            if (resp.Success) {
                resp.Data = resp.Data?.Select(x => typeof x == "string" ? JSON.parse(x) : x) as AIResponse[];
                // if(resp.Data!.Where(x=>x.))

            }

            return resp;
        }
    }

    /**
     * 生成图片
     * @param input 
     */
    public ImagesGenerationsAsync(input: InputImagesGenerations) {
        return Tools.FetchAsync("AI/ImagesGenerations", input, "POST");
    }

    /**
     * 文档解读
     */
    public DocumentInterpretationAsync(input: InputDocumentInterpretation, OnStreamFun?: (data: SSEResponse | '[DONE]') => void) {
        if (input.UseStream) {
            if (!OnStreamFun)
                throw new Error("流模式必须定义回调!");
            return Tools.FetchSSEAsync("AI/DocumentInterpretation", input, OnStreamFun);
        }
        else {
            return Tools.FetchAsync("AI/DocumentInterpretation", input, "POST");
        }
    }

    /**
     * 图片解读
     */
    public ImageInterpretationAsync(input: InputImageInterpretation, OnStreamFun?: (data: SSEResponse | '[DONE]') => void) {
        if (input.UseStream) {
            if (!OnStreamFun)
                throw new Error("流模式必须定义回调!");
            return Tools.FetchSSEAsync("AI/ImageInterpretation", input, OnStreamFun);
        }
        else {
            return Tools.FetchAsync("AI/ImageInterpretation", input, "POST");
        }
    }
}